import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation, useLoaderData } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import { SettingsProvider } from '../contexts/SettingsContext';
import { propertyAPI } from '../services/api';

const Layout: React.FC = () => {
    const reactNavigate = useNavigate();
    const location = useLocation();
    const loaderData = useLoaderData() as any;

    // React state for properties and search results
    const [properties, setProperties] = useState<any[]>(loaderData?.properties || []);
    const [searchResults, setSearchResults] = useState<any[]>([]);

    // Map react-router navigate to the old signature
    const navigate = (path: string) => {
        reactNavigate(path);
        window.scrollTo(0, 0);
    };

    // Keep properties in sync with loaderData when it changes (e.g. during page transitions/hydration)
    useEffect(() => {
        if (loaderData?.properties) {
            setProperties(loaderData.properties);
        }
    }, [loaderData?.properties]);

    // Fetch live properties client-side on mount to display newly added listings
    useEffect(() => {
        const fetchLiveProperties = async () => {
            try {
                const [fetchedProperties, unverifiedProperties] = await Promise.all([
                    propertyAPI.getAll(),
                    propertyAPI.getAll({ verified: false }),
                ]);

                const allProperties = [...fetchedProperties];
                unverifiedProperties.forEach((p) => {
                    if (!allProperties.some((existing) => existing.id === p.id)) {
                        allProperties.push(p);
                    }
                });

                setProperties(allProperties);
            } catch (error) {
                console.error('Failed to fetch live properties client-side:', error);
            }
        };

        fetchLiveProperties();
    }, []);

    const contextData = {
        ...loaderData,
        properties,
        searchResults,
        setSearchResults,
        navigate,
        pathname: location.pathname
    };

    return (
        <SettingsProvider>
            <div className="bg-white text-gray-800">
                <Header navigate={navigate} pathname={location.pathname} />
                <main className="pt-16">
                    <Outlet context={contextData} />
                </main>
                <Footer navigate={navigate} />
                <WhatsAppButton />
            </div>
        </SettingsProvider>
    );
};

export default Layout;
